import { render, staticRenderFns } from "./NbStepsCard.vue?vue&type=template&id=11030654&scoped=true&"
import script from "./NbStepsCard.vue?vue&type=script&lang=js&"
export * from "./NbStepsCard.vue?vue&type=script&lang=js&"
import style0 from "./NbStepsCard.vue?vue&type=style&index=0&id=11030654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11030654",
  null
  
)

export default component.exports